module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part-001"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "part_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA")])])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" Hosea (Heb "), _c('i', [_vm._v("hôšē"), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("ʿ")]), _vm._v("a")]), _vm._v(") is probably a")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("n abbreviation of “Yahweh saves.” He is listed as the first of the so-called twelve minor prophets. Hosea 1:1 dates the oracles of Hosea in the reigns of Uz-ziah, Jotham, Ahaz and Hezekiah of Judah and Jeroboam II of Israel. It is likely that his oracles began in the last years of the reigns of Jeroboam II (786-746 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("). Scholars do not agree when the last oracle was given. The tribute of Menahem of Israel to Assyria is probably reflected in Hosea 5:13, 7:11, 8:9, 10:5 and 12:2. Some scholars set the date at 725, just before the final siege of Samaria by the Assyrians, while others set it at the fall of the city in 721. There is, however, no specific evidence for this calamity in the book. Hosea was a subject of the northern kingdom, and his oracles related to that region. All we know about his life is that his father was Beeri and that he married.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Thematically the book falls into two large parts: Hosea 1—3 and Hosea 4—14. Hosea 1—3 contains the title and tells of Hosea’s marriage to Gomer (Hos 1:1-9), an oracle of restoration (Hos 1:10-11 [2:1-2 Heb]), Yahweh as the husband of Israel (Hos 2:1-23 [2:3-25 Heb]) and a personal account of Hosea’s marriage (Hos 3:1-5). Hosea 4—14 contains collections of oracles that display no discernable order.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("While the most significant interpreters were Jerome and Theodore of Mopsuestia, many other church fathers commented on this prophet. For others, such as Didymus the Blind, we have only fragments of a commentary written at the request of Jerome. Theodore of Mopsuestia approached Hosea mainly from a historical-grammatical orientation to arrive at the literal sense as a stepping stone in making typological connections with the Old Testament. As noted earlier, he limited himself to the Old Testament texts cited specifically as prophecy about Christ in the New Testament. Among others, Cyril of Alexandria used the allegorical method extensively to connect the Old Testament with the New Testament while maintaining the historicity of the events in question at the same time. Hosea yielded much regarding prophecies about Christ, the church and the sacraments of the new covenant.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSENCE OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA’S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETIC")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISTRY.")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v(": Blessed David had long foretold the disasters that would befall the people. This foretelling had its beginning at the time when Hezekiah reigned over Judah and Benjamin. It was at this time that divine grace communicated to the prophets when the events ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("were close at hand—although it was communicated to Hosea before the other prophets. He recounted what would befall the people from God as though he were recalling what was said by David in the dim and distant past. He would show how the Israelites were responsible for the coming disasters, having set aside worship and adoration of God while showering all their attention on idols and demons. Hosea was also to make it clear that this was not happening by chance. Rather, its occurrence had been told and foreseen well in advance by God. God understood this people’s wickedness and clearly realized how he needed to conduct affairs where they were concerned by way of preparing for the manifestation and coming of Christ the Lord. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA,")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN4",
      "id": "ap_NFIN4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW BY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREATS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTENDS TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESS.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v(": The divinely inspired Hosea thus received the charisma of prophecy, and on contemplating these things in retrospect with the eyes of the spirit he was bidden to make predictions to the people so that they might be frightened by the prophecies, avoid the punishments and not experience the troubles. The reason that the God of all threatens punishment, you see, is not to inflict it on those he threatens but to strike them with fear and lead them to repentance, and by ridding them of their wicked behavior extend to them salvation. After all, if he wanted to punish, he would not threaten punishment; instead, by threatening he makes clear that he longs to save and not to punish. Accordingly he sends blessed Hosea to foretell what would happen to the ten tribes and likewise to the two and to predict the salvation that would be achieved in the time of Sennacherib and to signal in advance the destruction that would be inflicted on them under the Babylonians. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA,")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN5",
      "id": "ap_NFIN5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b660ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1dev1.vue
// module id = 81
// module chunks = 0